import TagManager from 'react-gtm-module';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { PageTypes, LoggedInStatus } from 'common/consts/GtmVariableValues';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

export const getEncryptedValue = (userid?: string, countrycode?: string) => {
  let encodedUserId;
  if (!isNullOrWhiteSpace(userid)) {
    let hashDigest = sha256(userid + '_' + countrycode);
    encodedUserId = Base64.stringify(hashDigest);
  }
  return encodedUserId;
}
export const getGTMVariables = (userid?: string, isLoggedIn?: boolean, language?: string, region?: string, environment?: string, IsSecured:boolean = false, SecuredCaseStatus:string = '') => {

  var tagManagerArgs: any;
  if (!isNullOrWhiteSpace(userid)) {
    let encodedUserId = getEncryptedValue(userid,region)
    tagManagerArgs = {
      dataLayer: {
        event: 'page_data',
        user_id: encodedUserId,
        logged_in_status: isLoggedIn ? LoggedInStatus.LoggedIn : LoggedInStatus.LoggedOut,
        page_type: PageTypes.Portal,
        language: language,
        region: region,
        status_code: '200',
        environment: environment,
        ...(isLoggedIn && {is_secured_user: IsSecured}),
        ...(IsSecured && {secured_case_status : SecuredCaseStatus} )
      }
    }
  }
  else {
    tagManagerArgs = {
      dataLayer: {
        event: 'page_data',
        logged_in_status: isLoggedIn ? LoggedInStatus.LoggedIn : LoggedInStatus.LoggedOut,
        page_type: PageTypes.Portal,
        language: language,
        region: region,
        status_code: '200',
        environment: environment,
        ...(isLoggedIn && {is_secured_user: IsSecured}),
        ...(IsSecured && {secured_case_status : SecuredCaseStatus} )
      }
    }
  }
  TagManager.dataLayer(tagManagerArgs);
}

export const getGTMVariablesPageView = (pageTitle?: string, pageUrl?: string, pagePath?: string,userid?: string, isLoggedIn?: boolean, language?: string, region?: string, environment?: string) => {

  var tagManagerArgs: any;
  if (!isNullOrWhiteSpace(userid)) {
    let encodedUserId = getEncryptedValue(userid,region)
    tagManagerArgs = {
      dataLayer: {        
        event : 'vpv', 
        page_title : pageTitle, 
        page_url: pageUrl,
        page_path : pagePath,         
        user_id : encodedUserId, 
        logged_in_status : isLoggedIn ? LoggedInStatus.LoggedIn : LoggedInStatus.LoggedOut,
        language : language,
        region : region, 
        page_type : PageTypes.Portal,
        status_code : 200, 
        environment : environment
      }
    }
  }
  else {
    tagManagerArgs = {
      dataLayer: {
        event : 'vpv', 
        page_title : pageTitle, 
        page_url: pageUrl,
        page_path : pagePath,         
        logged_in_status : isLoggedIn ? LoggedInStatus.LoggedIn : LoggedInStatus.LoggedOut,
        language : language,
        region : region, 
        page_type : PageTypes.Portal,
        status_code : 200, 
        environment : environment
      }
    }
  }  
  TagManager.dataLayer(tagManagerArgs);
}

export const formProgression = (event: any, formName: any, fieldName: any, CallBack? : Function) => {
  
  var value = event.target.value;
  if(value !== null && value !== undefined && value !=="")
  {
  var tagManagerArgs: any;
  tagManagerArgs = {
    dataLayer: {
      event : "form_progression",
      form_name : formName, 
      form_element : fieldName
     }
    }
  
  TagManager.dataLayer(tagManagerArgs);

  if(CallBack !== undefined)
  {
    CallBack(event.target.value)
  }
  }
}


export const formError = (formName: any, fieldName: any, errorMessage? : any) => {

  
  var tagManagerArgs: any;
  tagManagerArgs = {
    dataLayer: {
      event : "form_error",
      form_name : formName, 
      form_element : fieldName,
      error_message : errorMessage ? errorMessage : ''
     }
    }
  
  TagManager.dataLayer(tagManagerArgs);

  
}
